document.addEventListener("DOMContentLoaded", () => {
  let pageHasRecomendations =
    document.querySelector(".product-recommendations") || false;
  let pageHasWishlist =
    document.querySelector(".wishlist__grid") || false;
  let timeout = pageHasRecomendations || pageHasWishlist ? 2000 : 0;

  setTimeout(function () {
    let quickViewModal = document.querySelector(".quick-view-container");

    if (quickViewModal) {
      let quickViewModalInner = quickViewModal.querySelector(".inner");
      let quickViewControls = document.querySelectorAll("[open-quick-view]");
      let quickViewClose = quickViewModal.querySelector(".close");
      let sectionName = "v2-main-product";
      // let sectionName = "test-section";

      quickViewControls.forEach((control) => {
        let handle = control.getAttribute("data-product-handle");
        // console.log('quickViewControls', quickViewControls)

        // console.log('handle', handle)

        if (handle) {
          // console.log('Attaching click event listener to control.');
          control.addEventListener("click", () => {
            // console.log(`Fetching data from /products/${handle}?sections=${sectionName}`);
            window.axios
              .get(`/products/${handle}?sections=${sectionName}`, {})
              .then(function (response) {
                // console.log('Received response:', response);
                // Success
                let script_index = 2;
                let html = response.data[`${sectionName}`];
                // console.log(`HTML content for ${sectionName}:`, html);
                let script_parts = html.split("<script>");
                script = script_parts[script_index].replace("</script>", "");
                script = script.replace("</div>", "");
                script = script.replace('document.addEventListener("DOMContentLoaded", function() {', "");
                let closingBraceLocation = script.lastIndexOf("})");
                script = script.substring(0, closingBraceLocation);
                // console.log('Script content:', script);
                
                if (quickViewModalInner && html) {
                  quickViewModalInner.innerHTML = html;
                  // eval(script);
                  getProductReview(html);
                  // init sliders
                  let gallery_thumbs_swiper = new window.swiper(
                    ".inner .thumb-swiper",
                    {
                      spaceBetween: 15,
                      slidesPerView: 'auto',
                      freeMode: true,
                      watchSlidesProgress: true,
                      breakpoints: {
                        992: {
                          slidesPerView: 'auto',
                          direction: "vertical",
                          watchSlidesProgress: true
                        },
                      },
                    }
                  );

                  let gallery_swiper = new window.swiper(
                    ".inner .main-swiper",
                    {
                      spaceBetween: 20,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      thumbs: {
                        swiper: gallery_thumbs_swiper,
                      },
                      on: {
                        init: function () {

                          let check_width = setInterval(() => {
                            setThumbHeight()
                          }, 200);

                          function setThumbHeight() {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper-slide');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (main_swiper_width > 0) {

                              clearInterval(check_width);

                              thumb_swiper.style.cssText = "position: relative;opacity:1";

                              if (window.innerWidth > 991.98) {
                                thumb_swiper.style.height = main_swiper_width + 'px';
                              }
                            }
                          }

                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          window.addEventListener('resize', () => {

                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let thumb_swiper_slide = document.querySelector('.inner .swiper-slide.thumb');
                            let thumb_swiper = document.querySelector('.inner .thumb-swiper');

                            let main_swiper_width = main_swiper_slide.offsetWidth;

                            main_swiper_slide.style.height = main_swiper_width + 'px';

                            if (window.innerWidth > 991.98) {

                              thumb_swiper.style.height = main_swiper_width + 'px';

                            }

                          });

                        }
                      },
                    }
                  );

                  // add listeners to product form
                  let productForm = quickViewModalInner.querySelector(
                    '[action="/cart/add"]'
                  );

                  if (productForm) {
                    productForm.addEventListener("submit", function (e) {
                      e.preventDefault();

                      let quantity = productForm.querySelector(
                        "input.quantity-selector"
                      ).value;
                      let id = productForm.querySelector("#product-id").value;

                      if (quantity && id) {
                        window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
                      }
                    });
                  }

                  // add listener for read more
                  let read_more = quickViewModalInner.querySelector(
                    ".product-description-container[read-more-qf]"
                  );

                  if (read_more) {
                    let read_more_control =
                      read_more.querySelector(".read-more");
                    let excerpt = read_more.querySelector("span.excerpt");
                    let full = read_more.querySelector("span.full");

                    read_more_control.addEventListener("click", () => {
                      if (read_more.classList.contains("active")) {
                        read_more.classList.remove("active");
                        read_more_control.innerHTML = "Read more";
                      } else {
                        read_more.classList.add("active");
                        read_more_control.innerHTML = "Read less";
                      }
                    });
                  }

                  quickViewModalInner.querySelector('.product-submit-wrapper').innerHTML = `<a href='/products/${handle}'>View full details</a>`

                  // Show quick view modal
                  document.querySelector('body').classList.add('locked')
                  quickViewModal.classList.add("active");
                }
              })
              .catch(function (error) {
                // handle error
                window.log("Error:", error);
              })
              .then(function () {
                // always executed
                window.log("Complete");
              });
          });
        }
      });

      const getProductReview = (html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const reviewBlock = parsedHTML.querySelector('.yotpo-widget-instance');
        const reviewAverage = parseFloat(reviewBlock.dataset.average);
        const reviewCount = parseInt(reviewBlock.dataset.count);
        const reviewPlace = quickViewModalInner.querySelector('.yotpo-widget-instance');
        let stars = "";
        
        function roundToHalf(value) {
          var converted = parseFloat(value); // Make sure we have a number
          var decimal = (converted - parseInt(converted, 10));
          decimal = Math.round(decimal * 10);
          if (decimal == 5) {
            return (parseInt(converted, 10) + 0.5);
          }
          if ((decimal < 3) || (decimal > 7)) {
            return Math.round(converted);
          } else {
            return (parseInt(converted, 10) + 0.5);
          }
        }
        
        const reviewAverageRounded = roundToHalf(reviewAverage);
      
        const floorReviewAverage = Math.floor(reviewAverageRounded);
        
        for (let i = 1; i <= 5; i++) {
          let icon_offset_1 = i <= floorReviewAverage ? "100%" : "0%";
          let icon_offset_2 = i <= floorReviewAverage ? "100%" : "0%";
          let icon_id = i <= floorReviewAverage ? "9650226208332289" : "7774917110587847";
          if (!Number.isInteger(reviewAverageRounded) && i === floorReviewAverage + 1) {
            icon_offset_1 = "51%";
            icon_offset_2 = "51%"; // Presuming 51% represents a half star
            icon_id = "7111190679284891";
          }
          stars += `<div class="star-container" style="display: flex; flex-direction: row; margin-right: 3.5px;">
                          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-labelledby="6067985055909-ada-star-ratings-text" width="15" height="15">
                              <defs>
                              <linearGradient aria-hidden="true" id="yotpo_stars_gradient_0.${icon_id}">
                                <stop offset="${icon_offset_1}" stop-color="#ECA300"></stop>
                                <stop stop-opacity="1" offset="${icon_offset_2}" stop-color="#FFFFFF"></stop>
                              </linearGradient>
                            </defs>
                            <path aria-hidden="true" style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#ECA300" fill="url('#yotpo_stars_gradient_0.${icon_id}')"></path>
                          </svg>
                        </div>`
            }
          let starsWrapper = `<div style="display: flex; flex-direction: row; align-items: center; margin-left: 0px;">${stars}</div>`;
          let starsWidget = `<div class="yotpo-reviews-star-ratings-widget yotpo-star-ratings-widget-override-css yotpo-device-desktop yotpo-display-l" style="display: flex; justify-content: left; flex-direction: row; margin-bottom: 3px;">  
                                <div class="yotpo-widget-clear"> 
                                  <div class="yotpo-bottom-line-scroll-panel" style="display: flex; align-items: flex-start; flex-flow: column wrap; gap: 4px;">
                                    <div class="yotpo-sr-bottom-line-summary" style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; margin-right: 0px; direction: ltr;"> 
                                      ${starsWrapper} 
                                        <div class="yotpo-sr-bottom-line-right-panel" style="display: flex;">
                                        <div class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; line-height: 18px; text-align: start; font-family: &quot;Open Sans&quot;; font-style: normal; font-weight: 300; color: rgb(44, 44, 44);">
                                        ${reviewCount} Reviews
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                          </div>`
            reviewPlace.innerHTML = starsWidget
      }
      document.querySelector(".quick-view-container .overlay").addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector('body').classList.remove('locked')
      });

      quickViewClose.addEventListener("click", () => {
        quickViewModal.classList.remove("active");
        document.querySelector('body').classList.remove('locked')
      });
    }
  }, timeout);
});
